module.exports = __webpack_public_path__ + "static/media/Logo-footer.7895baa9.svg";